import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { QueryOptions } from 'src/app/global/domain/query.options';
import { ResourceService } from 'src/app/global/services/resource.service';
import { WEB_API } from 'src/app/global/services/web-api';
import { ParcelaCobrancaJudicial } from '../domain/parcela-cobranca-judicial.model';
import { Produto } from '../domain/produto.model';
import { Page, ReturnAPI } from '../domain/return-api.model';
import { ParcelaCobrancaJudicialSerializer } from '../serializables/parcela-cobranca-judicial.serializer';

@Injectable()
export class ParcelaCobrancaJudicialService extends ResourceService<ParcelaCobrancaJudicial> {
  static RESOURCE = 'parcela-cobranca-judicial';
  produto: Produto;
  produtoId: string;

  constructor(private http: HttpClient) {
    super(http, `${WEB_API}`, `${ParcelaCobrancaJudicialService.RESOURCE}`, new ParcelaCobrancaJudicialSerializer(ParcelaCobrancaJudicial));
  }

  findAll(queryOption: QueryOptions): Observable<ReturnAPI<Page<ParcelaCobrancaJudicial>>> {
    this.getProduto();
    return this.httpClient.get<ReturnAPI<Page<ParcelaCobrancaJudicial>>>(
      `${WEB_API}/${ParcelaCobrancaJudicialService.RESOURCE}?${queryOption.toQueryString()}&${this.produtoId}`,
    );
  }

  baixaParcela(parcela: ParcelaCobrancaJudicial): Observable<ReturnAPI<ParcelaCobrancaJudicial>> {
    this.getProduto();
    return this.httpClient.post<ReturnAPI<ParcelaCobrancaJudicial>>(
      `${WEB_API}/${ParcelaCobrancaJudicialService.RESOURCE}/baixa-parcela?${this.produtoId}`,
      parcela,
    );
  }

  getProduto(): void {
    if (sessionStorage.getItem('produto')) {
      this.produto = JSON.parse(sessionStorage.getItem('produto'));
      this.produtoId = Number.isInteger(this.produto.id) ? 'produtoId=' + this.produto.id : '';
    }
  }
}
